import React from "react";
import "./Announcement.css"

function AnnouncementBookCard({name,img,url,stylee,imgStyle}) {
  return (
    <a className="CourseSliderCard" href={url} target="_blank" style={{...stylee,backgroundColor:'rgb(250,250,250)'}}>
      <img alt={name} src={img} className="AnnouncementBookCardImage" style={imgStyle}></img>
    </a>
  );
}

export default AnnouncementBookCard;
